import { DraftConfigurationText } from '@/types';
import { getTextSizeForStyle } from './getTextSizeForStyle';

export const getTextSize = (text: DraftConfigurationText) =>
  getTextSizeForStyle(text.style, text.content);
